var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInvalid = function SvgInvalid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 13",
    fill: "#F74A4A",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.947 10.993a6.44 6.44 0 1 0 9.106-9.107 6.44 6.44 0 0 0-9.106 9.107Zm7.285-7.286a.859.859 0 0 1 0 1.214L7.714 6.44l1.518 1.518a.859.859 0 1 1-1.214 1.214L6.5 7.653 4.982 9.171a.859.859 0 1 1-1.214-1.214l1.518-1.518-1.518-1.518a.859.859 0 0 1 1.214-1.214L6.5 5.225l1.518-1.518a.859.859 0 0 1 1.214 0Z"
  })));
};

export default SvgInvalid;